<template>
    <!-- Modal -->
    <div class="modal fade" id="autorizarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="value">
                <div class="modal-header">
                    <h5 class="modal-title">Autorização</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body">
                    <az-input
                        :label="value.fl_apac ? 'Nümero da APAC' : 'Número da Autorização / Senha'"
                        required
                        :validate="validate"
                        :edicao="value.in_status == 0"
                        v-model="value.st_codigo_autorizacao" />
                        
                    <az-input
                        label="Número da guia na operadora"
                        :validate="validate"
                        :edicao="value.in_status == 0"
                        v-model="value.st_guia_operadora" />

                    <az-input
                        label="Data da Autorização"
                        type="date"
                        required
                        :validate="validate"
                        :edicao="value.in_status == 0"
                        v-model="value.dt_autorizacao" />

                    <az-input
                        label="Validade De..."
                        type="date"
                        required
                        :validate="validate"
                        :edicao="value.in_status == 0"
                        v-model="value.dt_valid_inicio" />

                    <az-input
                        label="Validade Até..."
                        type="date"
                        required
                        :validate="validate"
                        :edicao="value.in_status == 0"
                        v-model="value.dt_valid_termino" />

                    <az-input
                        label="Comentários"
                        type="textarea"
                        rows="3"
                        :edicao="value.in_status == 0"
                        :validate="validate"
                        v-model="value.st_comentarios" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="autorizar_save()" :disabled="value.in_status != 0">Atualizar</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
export default {
    data() { 
        return { 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },
    
    props: ['value'],

    methods: { 
        autorizar_save() { 
            this.$util.atualizar(this, { 
                service: "solicitacao_autorizacoes",
                dados: this.value,
                modal: 'autorizarModal',
                reload: true, 
            });
        },
    }
}
</script>